// src/pages/NotFound.js
import React from "react";
export default function NotFound(){ return <div style={{padding:40}}>Page not found</div>; }
